import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '../pipes/pipes.module';
import { InvalidWhenDirective } from './invalid-when.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [InvalidWhenDirective],
  exports: [TranslateModule, PipesModule, InvalidWhenDirective]
})
export class SharedModule {}
